import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';

export const selectTaskState = (state: AppState) =>
  state.task;


export const selectTasks = createSelector(
  selectTaskState,
  (state) => state.tasks
);
export const selectTaskStates = createSelector(
  selectTaskState,
  (state) => state.states
);
export const selectTaskTypes = createSelector(
  selectTaskState,
  (state) => state.types
);
export const selectActiveTask = createSelector(
  selectTaskState,
  (state) => state.activeTask
);
export const selectStatusData = createSelector(
  selectTaskState,
  (state) => state.statusData
);
